import { render, staticRenderFns } from "./TimeOffAwaitingApproval.vue?vue&type=template&id=22b70f00&"
import script from "./TimeOffAwaitingApproval.vue?vue&type=script&lang=js&"
export * from "./TimeOffAwaitingApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports